import { SlidersHorizontal } from "lucide-react";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { FilterSidebar } from "@/components/filters";
import type { GeocodingResult } from "@/lib/geocoding";

interface FilterSheetProps {
  // Search
  searchQuery: string;
  onSearchChange: (query: string) => void;
  // Date Range
  startDate: string;
  endDate: string;
  onStartDateChange: (date: string) => void;
  onEndDateChange: (date: string) => void;
  // Location
  zipCode: string;
  onZipCodeChange: (zipCode: string) => void;
  distance: number;
  onDistanceChange: (distance: number) => void;
  location: GeocodingResult | null;
  onLocationChange: (location: GeocodingResult | null) => void;
  // Dance Styles
  selectedStyles: string[];
  onStyleChange: (styles: string[]) => void;
  // Favorites
  showFavoritesOnly: boolean;
  onFavoritesChange: (show: boolean) => void;
  // Sheet state
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function FilterSheet({
  open,
  onOpenChange,
  ...filterProps
}: FilterSheetProps) {
  // Count active filters
  const activeFilterCount =
    (filterProps.searchQuery ? 1 : 0) +
    (filterProps.startDate || filterProps.endDate ? 1 : 0) +
    (filterProps.zipCode.length === 5 ? 1 : 0) +
    filterProps.selectedStyles.length +
    (filterProps.showFavoritesOnly ? 1 : 0);

  return (
    <>
      {/* Floating action button — mobile only */}
      <button
        onClick={() => onOpenChange(true)}
        className="lg:hidden fixed bottom-6 right-6 z-40 w-10 h-10 rounded-full bg-primary text-primary-foreground shadow-lg flex items-center justify-center hover:bg-primary/90 active:scale-95 transition-all"
        aria-label="Open filters"
      >
        <SlidersHorizontal className="w-4 h-4" />
        {activeFilterCount > 0 && (
          <span className="absolute -top-1 -right-1 w-5 h-5 bg-destructive text-destructive-foreground text-xs font-medium rounded-full flex items-center justify-center">
            {activeFilterCount}
          </span>
        )}
      </button>

      {/* Bottom drawer */}
      <Sheet open={open} onOpenChange={onOpenChange}>
        <SheetContent side="bottom" className="max-h-[85vh] overflow-y-auto rounded-t-2xl">
          <SheetHeader className="mb-6">
            <SheetTitle>Filters</SheetTitle>
          </SheetHeader>
          <FilterSidebar {...filterProps} />
          <div className="pb-[env(safe-area-inset-bottom,1.5rem)]" />
        </SheetContent>
      </Sheet>
    </>
  );
}
